import { EnaioVariantInsertType } from "./EnaioVariantInsertType";

export class EnaioInsertVariantData {
    variantId: string;
    activate = false;
    insertType: EnaioVariantInsertType = EnaioVariantInsertType.asMain;
}
